import { Box, Flex, Skeleton, Text } from '@chakra-ui/react'
import React from 'react'

export interface MetricCardProps {
  label: string
  value: number | string
  unit?: string
  isLoading?: boolean
  valueColor?: string
}

const MetricCard: React.FC<MetricCardProps> = ({
  label,
  value,
  isLoading = false,
  valueColor,
}) => {
  if (isLoading) {
    return (
      <Box
        bg="bg.default"
        borderRadius="8px"
        border="1px solid"
        borderColor="border.default"
        padding="16px 20px"
        minHeight="80px"
        height="100%"
      >
        <Flex alignItems="center" gap="8px" mb="8px">
          <Skeleton height="14px" width="80px" />
        </Flex>
        <Skeleton height="28px" width="48px" />
      </Box>
    )
  }

  return (
    <Box
      bg="bg.default"
      borderRadius="8px"
      border="1px solid"
      borderColor="border.default"
      padding="16px 20px"
      minHeight="80px"
      height="100%"
    >
      <Text fontSize="0.75rem" fontWeight="500" color="fg.muted" mb="8px">
        {label}
      </Text>
      <Text
        fontSize="1.5rem"
        fontWeight="600"
        lineHeight="1.75rem"
        color={valueColor || 'fg.default'}
      >
        {value}
      </Text>
    </Box>
  )
}

export default MetricCard
